import { jsx as _jsx } from "react/jsx-runtime";
import Image from "@shared/components/contents/image/Image";
import BlockWithTitle from "./BlockWithTitle";
const BlockWithTitlePreview = () => {
    return (_jsx(BlockWithTitle, { image: _jsx(Image, { file: { url: "/exemple-image.jpg" }, disableLazy: true }), title: "Titre", justify: "flex-start", backgroundColor: "#F5F5F5" }));
};
export default BlockWithTitlePreview;
